<template>
  <div>
    <h1>{{$t('app.edas_invoize_redirect')}}</h1>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
